import { Component, OnInit } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { Location } from '@angular/common';
import { CadastrarFornecedorService } from './cadastrar-fornecedor.service';
import { NotificationsService } from 'angular2-notifications';
import { EnderecoUtils } from '../../../../../shared/utils/EnderecoUtils';
import { DocumentoHelper } from '../../../../../shared/utils/documento.helper';

@Component({
  selector: 'ngx-cadastrar-fornecedor',
  templateUrl: './cadastrar-fornecedor.component.html',
  styleUrls: ['./cadastrar-fornecedor.component.scss']
})
export class CadastrarFornecedorComponent implements OnInit {

  public formCadastraFornecedor = null;
  public pessoaJuridica = false;
  public pessoaFisica = false;
  public endereco = false;
  public listaEstado = null;
  public tipoFornecedor = null;
  public cpfCnpj = null;
  public razaoSocial = null;
  public listaTplogradouro = null;
  public customLogin = null;
  /** Auxiliares de máscara (ngx-mask + DocumentoHelper) para CPF e CNPJ. */
  public cpfMaskAux = null;
  public cnpjMaskAux = null;

  constructor(
    private formBuilder: FormBuilder,
    private location: Location,
    private service: CadastrarFornecedorService,
    private notifications: NotificationsService,
    private CadastrarFornecedorService: CadastrarFornecedorService,
    private enderecoUtils: EnderecoUtils,
  ) {

    this.listaTplogradouro = [

      {
        localidade: 'AVENIDA',
        descricao: 'Avenida'
      },

      {
        localidade: 'RUA',
        descricao: 'Rua'
      },

      {
        localidade: 'FAZENDA',
        descricao: 'Fazenda'
      },

      {
        localidade: 'LOTEAMENTO',
        descricao: 'Loteamento'
      },

      {
        localidade: 'RODOVIA',
        descricao: 'Rodovia'
      },

      {
        localidade: 'PRAÇA',
        descricao: 'Praça'
      },

      {
        localidade: 'OUTRO',
        descricao: 'Outro'
      }
    ]

    this.listaEstado = this.enderecoUtils.ufList;

    this.formCadastraFornecedor = this.formBuilder.group({
      nome: [null],
      cpf: [null],
      razaoSocial: [null],
      cnpj: [null],
      numero: [null],
      logradouro: [null],
      tipoLogradouro: [null],
      complemento: [null],
      bairro: [null],
      localidade: [null],
      estado: [null],
      cep: [null],
      inscricaoEstadual: [null],
    });

  }

  viewdiv(data) {

    this.endereco = true;
    this.cpfMaskAux = null;
    this.cnpjMaskAux = null;

    if (data === 'PESSOA_FISICA') {
      this.limparForm();
      this.pessoaFisica = true
      this.pessoaJuridica = false;
      this.tipoFornecedor = data;

    } else {
      this.limparForm();
      this.pessoaJuridica = true;
      this.pessoaFisica = false;
      this.tipoFornecedor = data;

    }

  }

  salveCadastro(data) {

    //let data = this.formCadastraFornecedor.value;
    let tipoFornecedor = this.tipoFornecedor;
    data.tipoFornecedor = tipoFornecedor;

    const cpfStr = data.cpf != null ? String(data.cpf).trim() : '';
    const cnpjStr = data.cnpj != null ? String(data.cnpj).trim() : '';

    if (cpfStr !== '') {
      this.cpfCnpj = this.normalizarCnpjCpfParaBackend(data.cpf);
      this.razaoSocial = data.nome;
    } else if (cnpjStr !== '') {
      this.cpfCnpj = this.normalizarCnpjCpfParaBackend(data.cnpj);
      this.razaoSocial = data.razaoSocial;
    } else {
      this.cpfCnpj = null;
      this.razaoSocial = null;
    }

    let register = {
      endereco: {
        bairro: data.bairro,
        cep: data.cep,
        complemento: data.complemento,
        estado: data.estado,
        localidade: data.localidade,
        logradouro: data.logradouro,
        numero: data.numero,
        tipo: data.tipo,
        tipoLogradouro: data.tipoLogradouro,
      },
      fornecedor: {
        cpfCnpj: this.cpfCnpj,
        inscricaoEstadual: data.inscricaoEstadual,
        razaoSocial: this.razaoSocial,
        tipoFornecedor: data.tipoFornecedor,
      }
    }

    this.service.saveRegisterSupplier(
      register,
      (resp) => {
        this.notifications.success('Registro Salvo com sucesso!');
        this.limparForm();
      }, (error) => {
        this.notifications.error(error.message);
      })

  }

  consultaCEP(data) {

    this.CadastrarFornecedorService.address(data, null, (response) => {
      this.buscaEndereco(response)
    }, null)
  }

  buscaEndereco(data) {

    if (data.cep === null) {
      this.notifications.error('CEP não existe!!!');
    } else {

      let tipoLogradouro = data.logradouro.split(" ")[0];
      let logradouro = data.logradouro.split(tipoLogradouro + " ")[1];

      this.formCadastraFornecedor.controls['cep'].setValue(data.cep);
      this.formCadastraFornecedor.controls['estado'].setValue(data.estado);
      this.formCadastraFornecedor.controls['logradouro'].setValue(logradouro);
      this.formCadastraFornecedor.controls['tipoLogradouro'].setValue(tipoLogradouro);
      this.formCadastraFornecedor.controls['complemento'].setValue(data.complemento);
      this.formCadastraFornecedor.controls['localidade'].setValue(data.localidade);
      this.formCadastraFornecedor.controls['estado'].setValue(data.uf);
      this.formCadastraFornecedor.controls['bairro'].setValue(data.bairro);


    }
  }

  numberOnly(event): boolean {

    const charCode = (event.which) ? event.which : event.keyCode;
    if (charCode > 31 && (charCode < 48 || charCode > 57)) {
      return false;
    }
    return true;

  }

  getCpfMascaraFornecedor(): string {
    const ctrl = this.formCadastraFornecedor && this.formCadastraFornecedor.get('cpf');
    const doForm = ctrl ? ctrl.value : null;
    const raw =
      this.cpfMaskAux != null && String(this.cpfMaskAux).trim() !== ''
        ? this.cpfMaskAux
        : doForm;
    return DocumentoHelper.getMascaraCpfCnpj(raw);
  }

  getCnpjMascaraFornecedor(): string {
    const ctrl = this.formCadastraFornecedor && this.formCadastraFornecedor.get('cnpj');
    const doForm = ctrl ? ctrl.value : null;
    const raw =
      this.cnpjMaskAux != null && String(this.cnpjMaskAux).trim() !== ''
        ? this.cnpjMaskAux
        : doForm;
    return DocumentoHelper.getMascaraCpfCnpj(raw);
  }

  private normalizarCnpjCpfParaBackend(value: any): string {
    if (value == null) return '';
    const str = String(value);
    if (str === '') return '';
    const tipo = DocumentoHelper.detectarTipoDocumento(str);
    return DocumentoHelper.normalizarParaEnvio(str, tipo);
  }

  limparForm() {
    this.cpfMaskAux = null;
    this.cnpjMaskAux = null;
    this.formCadastraFornecedor = this.formBuilder.group({
      nome: [null],
      cpf: [null],
      razaoSocial: [null],
      cnpj: [null],
      numero: [null],
      logradouro: [null],
      tipoLogradouro: [null],
      complemento: [null],
      bairro: [null],
      localidade: [null],
      estado: [null],
      cep: [null],
      inscricaoEstadual: [null],
    });

  }

  ngOnInit() {

    let resCustom = localStorage.getItem('bway-customLogin');
    this.customLogin = JSON.parse(resCustom);
    document.title = this.customLogin.title;

  }

  previousPage() {
    this.location.back();
  }

  getButtonPrimaria() {
    if (this.customLogin != null) {
      return this.customLogin.primaria;
    }
  }

  getButtonSecundaria() {
    if (this.customLogin != null) {
      return this.customLogin.secundaria;
    }
  }

  getButtonTerciario() {
    if (this.customLogin != null) {
      return this.customLogin.terciario;
    }
  }
}
